// extracted by mini-css-extract-plugin
export default {"grid":"BenefitsSection_grid__kxZBz","title":"BenefitsSection_title__xslaE","desc":"BenefitsSection_desc__LniP0"};